import { Box, Typography, useTheme } from "@mui/material";
import { FC, useMemo } from "react";
import { useLocalization } from "../../../hooks/useLocalization";
import { formatDateYMD } from "../../../shared/utils/date";
import { EditButton } from "./EditButton";

export const ExpirationDateView: FC<{
  expirationDate?: Date | null;
  onClick?: () => void;
}> = ({ expirationDate, onClick }) => {
  const { t } = useLocalization();
  const theme = useTheme();

  const formattedDate = useMemo(() => {
    if (!expirationDate) return t("licenses.unlimited");

    return formatDateYMD(expirationDate);
  }, [expirationDate, t]);

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Typography
        sx={{
          fontWeight: 500,
          fontSize: 14,
          color: theme.colors.text[5],
        }}
      >
        {formattedDate}
      </Typography>
      <EditButton onClick={onClick} />
    </Box>
  );
};
